import { render, staticRenderFns } from "./multipleChoiceQuestion.vue?vue&type=template&id=21b5d346&scoped=true&"
import script from "./multipleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./multipleChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./multipleChoiceQuestion.vue?vue&type=style&index=0&id=21b5d346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5d346",
  null
  
)

export default component.exports